import actions from './actions';
import mutations from './mutations';

export default {
  state: {
    packages: [],
    packageFiles: [],
    newPackage: {}, // Used when creating new packages.
    summaryDateRange: { start: null, end: null },
  },
  mutations,
  actions,
};
